export const CommonMutationCrumbs = [
  {
    name: 'Home',
    path: '/',
  },
  {
    name: 'Mutazioni',
    path: '/mutazioni',
  },
];
